import { useQuery, skipToken } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { DashboardTransactionsSummaryParams } from 'config/requests/dashboard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TransactionsAmountSummary } from 'types/embedded/dashboard';
import { ErrorData } from 'types/embedded/error';

import { useDashboardApi } from './useDashboardApi';

export function useGetDashboardTransactionsSummary(
  params: DashboardTransactionsSummaryParams | null,
) {
  const translate = useTypedTranslate();
  const { api, aggregatedQueryKey } = useDashboardApi();

  const {
    data: summary,
    isLoading,
    isFetching,
    error,
  } = useQuery<TransactionsAmountSummary, AxiosError<ErrorData>>({
    queryKey: ['dashboard/executed_transactions_amount', aggregatedQueryKey, params],
    queryFn: params ? () => api.getTransactionsSummary(params) : skipToken,
  });

  const errorMessage = error
    ? error.response?.data?.errors?.[0].title || translate('app.common.serverError')
    : undefined;

  return { summary, isLoading, isFetching, error: errorMessage };
}

export type GetDashboardTransactionsSummaryResult = ReturnType<
  typeof useGetDashboardTransactionsSummary
>;
